import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import Store from 'drip/store';
import KNB from '@dp/knb';
import { getUserBehaviorStrategy, getUserBehaviorCoupon } from '@/request/detail-new/index';
import { getIsAbTestForUserBehavior } from '@/request/abtest';
import { owlReportError } from '@/utils/monitor-err/index';
import Drip from 'drip';
var USER_BEHAVIOR_STRATEGY_KEY = 'performance_detail_behavior_strategy';
var USER_BEHAVIOR_COUPON_RECEIVED_KEY = 'performance_detail_behavior_coupon_received';
var UserBehavior = /*#__PURE__*/function () {
  function UserBehavior(showUserBehaviorCouponModal, changeCouponStatus) {
    _classCallCheck(this, UserBehavior);
    this.userBehaviorClick = 0;
    this.abTest = false;
    this.couponStrategy = [];
    this.couponStrategyWillCheck = [];
    this.stayTime = 0;
    this.startEnterTime = 0;
    this.userBehaviorCompareTimer = null;
    this.behaviorInStore = [];
    this.showUserBehaviorCouponModal = showUserBehaviorCouponModal;
    this.changeCouponStatus = changeCouponStatus;
  }
  _createClass(UserBehavior, [{
    key: "getFromStore",
    value: function () {
      var _getFromStore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
        var behavior;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Store === null || Store === void 0 ? void 0 : Store.get(key);
            case 3:
              behavior = _context.sent;
              if (!(behavior && Array.isArray(behavior) && (behavior === null || behavior === void 0 ? void 0 : behavior.length) > 0)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", behavior === null || behavior === void 0 ? void 0 : behavior.filter(function (item) {
                var _item$st, _item$st2;
                return (item === null || item === void 0 ? void 0 : (_item$st = item.st) === null || _item$st === void 0 ? void 0 : _item$st.lt) && Date.now() - (item === null || item === void 0 ? void 0 : (_item$st2 = item.st) === null || _item$st2 === void 0 ? void 0 : _item$st2.lt) < 1000 * 60 * 15;
              }));
            case 6:
              return _context.abrupt("return", []);
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", []);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      function getFromStore(_x) {
        return _getFromStore.apply(this, arguments);
      }
      return getFromStore;
    }() // 获取该用户该项目id下的操作
  }, {
    key: "getUserBehaviorByPid",
    value: function getUserBehaviorByPid(pid) {
      try {
        return (this.behaviorInStore || []).filter(function (e) {
          return (e === null || e === void 0 ? void 0 : e.pid) === pid;
        });
      } catch (error) {
        return [];
      }
    }

    // 计算【其他项目】
  }, {
    key: "getUserBehaviorByStrategyId",
    value: function getUserBehaviorByStrategyId(strategyId, pid) {
      try {
        var _filter;
        return (_filter = (this.behaviorInStore || []).filter(function (e) {
          var _e$strategyIds;
          return (e === null || e === void 0 ? void 0 : (_e$strategyIds = e.strategyIds) === null || _e$strategyIds === void 0 ? void 0 : _e$strategyIds.includes(strategyId)) && (e === null || e === void 0 ? void 0 : e.pid) !== pid;
        })) === null || _filter === void 0 ? void 0 : _filter.reduce(function (acc, current) {
          var _current$st, _acc$existingIndex, _acc$existingIndex$st;
          // 2. 按 pid 去重，保留 st 最大的记录
          var existingIndex = acc.findIndex(function (item) {
            return (item === null || item === void 0 ? void 0 : item.pid) === (current === null || current === void 0 ? void 0 : current.pid);
          });
          if (existingIndex === -1) {
            acc.push(current);
          } else if ((current === null || current === void 0 ? void 0 : (_current$st = current.st) === null || _current$st === void 0 ? void 0 : _current$st.duration) > ((_acc$existingIndex = acc[existingIndex]) === null || _acc$existingIndex === void 0 ? void 0 : (_acc$existingIndex$st = _acc$existingIndex.st) === null || _acc$existingIndex$st === void 0 ? void 0 : _acc$existingIndex$st.duration)) {
            acc[existingIndex] = current; // 替换为  st 更大的记录
          }

          return acc;
        }, []);
      } catch (error) {
        return [];
      }
    }

    // 过滤掉不需要对比的策略
  }, {
    key: "filterStrategy",
    value: function filterStrategy(couponStrategy, performanceId) {
      var _this = this;
      try {
        var _couponStrategy$map;
        return (couponStrategy === null || couponStrategy === void 0 ? void 0 : (_couponStrategy$map = couponStrategy.map(function (item) {
          var _item$strategyRuleLis, _item$strategyRuleLis2;
          var validRules = (item === null || item === void 0 ? void 0 : (_item$strategyRuleLis = item.strategyRuleList) === null || _item$strategyRuleLis === void 0 ? void 0 : (_item$strategyRuleLis2 = _item$strategyRuleLis.map(function (strategyRule) {
            if ((strategyRule === null || strategyRule === void 0 ? void 0 : strategyRule.ruleType) === 1) return strategyRule;
            if ((strategyRule === null || strategyRule === void 0 ? void 0 : strategyRule.ruleType) === 2) {
              var behaviorList = _this.getUserBehaviorByStrategyId(item === null || item === void 0 ? void 0 : item.strategyId, performanceId);
              var stList = behaviorList === null || behaviorList === void 0 ? void 0 : behaviorList.filter(function (e) {
                var _e$st;
                return (e === null || e === void 0 ? void 0 : (_e$st = e.st) === null || _e$st === void 0 ? void 0 : _e$st.duration) >= (strategyRule === null || strategyRule === void 0 ? void 0 : strategyRule.stopTime) * 1000;
              });
              return (stList === null || stList === void 0 ? void 0 : stList.length) > (strategyRule === null || strategyRule === void 0 ? void 0 : strategyRule.visits) ? strategyRule : null;
            }
            if ((strategyRule === null || strategyRule === void 0 ? void 0 : strategyRule.ruleType) === 3) {
              var _behaviorList = _this.getUserBehaviorByPid(performanceId);
              return (_behaviorList === null || _behaviorList === void 0 ? void 0 : _behaviorList.length) > (strategyRule === null || strategyRule === void 0 ? void 0 : strategyRule.visits) ? strategyRule : null;
            }
            return null;
          })) === null || _item$strategyRuleLis2 === void 0 ? void 0 : _item$strategyRuleLis2.filter(function (rule) {
            return rule !== null;
          })) || [];
          return validRules.length > 0 ? Object.assign({}, item, {
            strategyRuleList: validRules
          }) : null;
        })) === null || _couponStrategy$map === void 0 ? void 0 : _couponStrategy$map.filter(function (item) {
          return item !== null;
        })) || [];
      } catch (error) {
        return [];
      }
    }
  }, {
    key: "getSuccessStrategy",
    value: function getSuccessStrategy(couponStrategyWillCheck, userBehaviorClick, stayTime) {
      try {
        var _couponStrategyWillCh;
        var successCouponStrategyList = couponStrategyWillCheck === null || couponStrategyWillCheck === void 0 ? void 0 : (_couponStrategyWillCh = couponStrategyWillCheck.map(function (item) {
          var _item$strategyRuleLis3;
          var filteredRules = item === null || item === void 0 ? void 0 : (_item$strategyRuleLis3 = item.strategyRuleList) === null || _item$strategyRuleLis3 === void 0 ? void 0 : _item$strategyRuleLis3.filter(function (s) {
            return (s === null || s === void 0 ? void 0 : s.ruleType) === 1 ? userBehaviorClick > (s === null || s === void 0 ? void 0 : s.visits) && stayTime > (s === null || s === void 0 ? void 0 : s.stopTime) : stayTime > (s === null || s === void 0 ? void 0 : s.stopTime);
          });
          return (filteredRules === null || filteredRules === void 0 ? void 0 : filteredRules.length) > 0 ? Object.assign({}, item, {
            strategyRuleList: filteredRules
          }) : null;
        })) === null || _couponStrategyWillCh === void 0 ? void 0 : _couponStrategyWillCh.filter(function (item) {
          return item !== null;
        });
        return successCouponStrategyList || [];
      } catch (error) {
        return [];
      }
    }
  }, {
    key: "getStrategy2List",
    value: function getStrategy2List(couponStrategy) {
      try {
        return Array.from(new Set(couponStrategy.reduce(function (acc, item) {
          var _item$strategyRuleLis4;
          var rule2 = item === null || item === void 0 ? void 0 : (_item$strategyRuleLis4 = item.strategyRuleList) === null || _item$strategyRuleLis4 === void 0 ? void 0 : _item$strategyRuleLis4.find(function (rule) {
            return (rule === null || rule === void 0 ? void 0 : rule.ruleType) === 2;
          });
          (rule2 === null || rule2 === void 0 ? void 0 : rule2.stopTime) && acc.push(rule2.stopTime);
          return acc;
        }, []))).sort(function (a, b) {
          return a - b;
        });
      } catch (error) {
        return [];
      }
    }
  }, {
    key: "startBehaviorTimer",
    value: function () {
      var _startBehaviorTimer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(strategy2List, performanceId) {
        var _this2 = this;
        var _this$couponStrategyW, _this$couponStrategyW2;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!((strategy2List === null || strategy2List === void 0 ? void 0 : strategy2List.length) === 0 && ((_this$couponStrategyW = this.couponStrategyWillCheck) === null || _this$couponStrategyW === void 0 ? void 0 : _this$couponStrategyW.length) === 0)) {
                _context2.next = 4;
                break;
              }
              this.clearBehaviorTimer();
              return _context2.abrupt("return");
            case 4:
              this.stayTime = this.stayTime + 1;
              if (strategy2List.length > 0 && this.stayTime > (strategy2List === null || strategy2List === void 0 ? void 0 : strategy2List[0])) {
                this.record(performanceId, this.stayTime);
                strategy2List.shift();
              }
              if (!(((_this$couponStrategyW2 = this.couponStrategyWillCheck) === null || _this$couponStrategyW2 === void 0 ? void 0 : _this$couponStrategyW2.length) > 0)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 9;
              return this.compare(performanceId);
            case 9:
              if (this.userBehaviorCompareTimer) {
                this.userBehaviorCompareTimer = setTimeout(function () {
                  _this2.startBehaviorTimer(strategy2List, performanceId);
                }, 1000);
              }
              _context2.next = 15;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              owlReportError === null || owlReportError === void 0 ? void 0 : owlReportError('项目详情页-用户行为策略-启动行为定时器异常', _context2.t0, {
                projectId: performanceId
              });
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 12]]);
      }));
      function startBehaviorTimer(_x2, _x3) {
        return _startBehaviorTimer.apply(this, arguments);
      }
      return startBehaviorTimer;
    }() // 初始化用户行为策略
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;
        var hasInit,
          performanceId,
          _Drip$UA,
          abTest,
          received,
          strategyRes,
          _ref,
          couponStrategy,
          success,
          _this$couponStrategyW3,
          strategy2List,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              hasInit = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
              performanceId = _args5.length > 1 ? _args5[1] : undefined;
              _context5.prev = 2;
              if (!(this.userBehaviorCompareTimer || !performanceId)) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return");
            case 5:
              if (!hasInit && Drip !== null && Drip !== void 0 && (_Drip$UA = Drip.UA) !== null && _Drip$UA !== void 0 && _Drip$UA.isNative) {
                KNB.subscribe({
                  action: 'appear',
                  handle: function () {
                    var _handle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _this3.init(true, performanceId);
                          case 2:
                          case "end":
                            return _context3.stop();
                        }
                      }, _callee3);
                    }));
                    function handle() {
                      return _handle.apply(this, arguments);
                    }
                    return handle;
                  }()
                });
                KNB.subscribe({
                  action: 'disappear',
                  handle: function handle() {
                    _this3.reset(performanceId);
                  }
                });
                KNB.subscribe({
                  action: 'foreground',
                  handle: function () {
                    var _handle2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return _this3.init(true, performanceId);
                          case 2:
                          case "end":
                            return _context4.stop();
                        }
                      }, _callee4);
                    }));
                    function handle() {
                      return _handle2.apply(this, arguments);
                    }
                    return handle;
                  }()
                });
                KNB.subscribe({
                  action: 'background',
                  handle: function handle() {
                    _this3.reset(performanceId);
                  }
                });
              }
              abTest = false; // 避免appear时重复请求
              if (!hasInit) {
                _context5.next = 11;
                break;
              }
              abTest = this.abTest;
              _context5.next = 15;
              break;
            case 11:
              _context5.next = 13;
              return getIsAbTestForUserBehavior();
            case 13:
              abTest = _context5.sent;
              this.abTest = abTest;
            case 15:
              if (abTest) {
                _context5.next = 17;
                break;
              }
              return _context5.abrupt("return");
            case 17:
              received = false;
              _context5.next = 20;
              return Store.get(USER_BEHAVIOR_COUPON_RECEIVED_KEY);
            case 20:
              received = _context5.sent;
              if (!received) {
                _context5.next = 23;
                break;
              }
              return _context5.abrupt("return");
            case 23:
              _context5.next = 25;
              return getUserBehaviorStrategy(performanceId);
            case 25:
              strategyRes = _context5.sent;
              _ref = strategyRes || {}, couponStrategy = _ref.data, success = _ref.success;
              if (!(success && (couponStrategy === null || couponStrategy === void 0 ? void 0 : couponStrategy.length) > 0)) {
                _context5.next = 40;
                break;
              }
              this.couponStrategy = couponStrategy;
              strategy2List = this.getStrategy2List(couponStrategy);
              this.startEnterTime = Date.now();
              _context5.next = 33;
              return this.getFromStore(USER_BEHAVIOR_STRATEGY_KEY);
            case 33:
              this.behaviorInStore = _context5.sent;
              this.record(performanceId);
              this.couponStrategyWillCheck = this.filterStrategy(couponStrategy, performanceId);
              if (!((strategy2List === null || strategy2List === void 0 ? void 0 : strategy2List.length) === 0 && ((_this$couponStrategyW3 = this.couponStrategyWillCheck) === null || _this$couponStrategyW3 === void 0 ? void 0 : _this$couponStrategyW3.length) === 0)) {
                _context5.next = 38;
                break;
              }
              return _context5.abrupt("return");
            case 38:
              // 防御代码
              this.clearBehaviorTimer();
              this.userBehaviorCompareTimer = setTimeout(function () {
                _this3.startBehaviorTimer(strategy2List, performanceId);
              }, 1000);
            case 40:
              _context5.next = 45;
              break;
            case 42:
              _context5.prev = 42;
              _context5.t0 = _context5["catch"](2);
              owlReportError === null || owlReportError === void 0 ? void 0 : owlReportError('项目详情页-用户行为策略-初始化异常', _context5.t0, {
                projectId: performanceId
              });
            case 45:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[2, 42]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }() // 对比用户行为命中策略
  }, {
    key: "compare",
    value: function () {
      var _compare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId) {
        var successCouponStrategyList, _maxWeightStrategy$st, _maxWeightStrategy$st2, maxWeightStrategy, userBehaviorCouponRes, _ref2, success, data, _this$showUserBehavio, _this$changeCouponSta, expires;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              // 过滤保留比较成功的
              successCouponStrategyList = this.getSuccessStrategy(this.couponStrategyWillCheck, this.userBehaviorClick, this.stayTime);
              if (!((successCouponStrategyList === null || successCouponStrategyList === void 0 ? void 0 : successCouponStrategyList.length) > 0)) {
                _context6.next = 17;
                break;
              }
              this.reset(projectId);
              maxWeightStrategy = successCouponStrategyList === null || successCouponStrategyList === void 0 ? void 0 : successCouponStrategyList.reduce(function (maxItem, currentItem) {
                return maxItem && maxItem.weight > (currentItem === null || currentItem === void 0 ? void 0 : currentItem.weight) ? maxItem : currentItem;
              }, null);
              if (maxWeightStrategy) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return");
            case 7:
              _context6.next = 9;
              return getUserBehaviorCoupon(projectId, maxWeightStrategy === null || maxWeightStrategy === void 0 ? void 0 : maxWeightStrategy.strategyId, maxWeightStrategy === null || maxWeightStrategy === void 0 ? void 0 : (_maxWeightStrategy$st = maxWeightStrategy.strategyRuleList) === null || _maxWeightStrategy$st === void 0 ? void 0 : (_maxWeightStrategy$st2 = _maxWeightStrategy$st[0]) === null || _maxWeightStrategy$st2 === void 0 ? void 0 : _maxWeightStrategy$st2.ruleId);
            case 9:
              userBehaviorCouponRes = _context6.sent;
              _ref2 = userBehaviorCouponRes || {}, success = _ref2.success, data = _ref2.data;
              if (!(success && data)) {
                _context6.next = 17;
                break;
              }
              (_this$showUserBehavio = this.showUserBehaviorCouponModal) === null || _this$showUserBehavio === void 0 ? void 0 : _this$showUserBehavio.call(this, data);
              expires = data !== null && data !== void 0 && data.lockTime ? Math.ceil((data === null || data === void 0 ? void 0 : data.lockTime) / 60) : 5;
              Store.set(USER_BEHAVIOR_COUPON_RECEIVED_KEY, true, {
                expires: "".concat(expires, "M")
              });
              _context6.next = 17;
              return (_this$changeCouponSta = this.changeCouponStatus) === null || _this$changeCouponSta === void 0 ? void 0 : _this$changeCouponSta.call(this, true);
            case 17:
              _context6.next = 22;
              break;
            case 19:
              _context6.prev = 19;
              _context6.t0 = _context6["catch"](0);
              owlReportError === null || owlReportError === void 0 ? void 0 : owlReportError('项目详情页-用户行为策略-对比用户行为异常', _context6.t0, {
                projectId: projectId
              });
            case 22:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 19]]);
      }));
      function compare(_x4) {
        return _compare.apply(this, arguments);
      }
      return compare;
    }()
  }, {
    key: "click",
    value: function click() {
      try {
        var _this$couponStrategyW4;
        if (((_this$couponStrategyW4 = this.couponStrategyWillCheck) === null || _this$couponStrategyW4 === void 0 ? void 0 : _this$couponStrategyW4.length) > 0) {
          this.userBehaviorClick = this.userBehaviorClick + 1;
        }
      } catch (error) {
        owlReportError === null || owlReportError === void 0 ? void 0 : owlReportError('项目详情页-用户行为策略-点击用户行为异常', error);
      }
    }
  }, {
    key: "record",
    value: function record(projectId) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      try {
        var _this$couponStrategy;
        if (((_this$couponStrategy = this.couponStrategy) === null || _this$couponStrategy === void 0 ? void 0 : _this$couponStrategy.length) > 0 && this.startEnterTime !== 0) {
          var _this$couponStrategy2;
          var newBehavior = {
            pid: projectId,
            st: {
              duration: duration * 1000,
              lt: this.startEnterTime
            },
            strategyIds: (_this$couponStrategy2 = this.couponStrategy) === null || _this$couponStrategy2 === void 0 ? void 0 : _this$couponStrategy2.map(function (item) {
              return item === null || item === void 0 ? void 0 : item.strategyId;
            })
          };
          if (duration === 0) {
            var _this$behaviorInStore;
            (_this$behaviorInStore = this.behaviorInStore) === null || _this$behaviorInStore === void 0 ? void 0 : _this$behaviorInStore.push(newBehavior);
          } else {
            var _this$behaviorInStore2, _this$behaviorInStore3;
            ((_this$behaviorInStore2 = this.behaviorInStore) === null || _this$behaviorInStore2 === void 0 ? void 0 : _this$behaviorInStore2.length) && (this.behaviorInStore[((_this$behaviorInStore3 = this.behaviorInStore) === null || _this$behaviorInStore3 === void 0 ? void 0 : _this$behaviorInStore3.length) - 1] = newBehavior);
          }
          Store.set(USER_BEHAVIOR_STRATEGY_KEY, this.behaviorInStore, {
            expires: '15M'
          });
        }
      } catch (error) {
        owlReportError === null || owlReportError === void 0 ? void 0 : owlReportError('项目详情页-用户行为策略-记录用户行为异常', error, {
          projectId: projectId
        });
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      try {
        this.startEnterTime = 0;
        this.couponStrategy = [];
        this.couponStrategyWillCheck = [];
        this.userBehaviorClick = 0;
        this.stayTime = 0;
        this.behaviorInStore = [];
        this.clearBehaviorTimer();
      } catch (error) {
        owlReportError === null || owlReportError === void 0 ? void 0 : owlReportError('项目详情页-用户行为策略-重置用户行为异常', error);
      }
    }
  }, {
    key: "clearBehaviorTimer",
    value: function clearBehaviorTimer() {
      try {
        if (this.userBehaviorCompareTimer) {
          clearTimeout(this.userBehaviorCompareTimer);
          this.userBehaviorCompareTimer = null;
        }
      } catch (error) {
        owlReportError === null || owlReportError === void 0 ? void 0 : owlReportError('项目详情页-用户行为策略-清除行为定时器异常', error);
      }
    }
  }]);
  return UserBehavior;
}();
export default UserBehavior;